import React from "react"

import type { PaginatedData } from "../use-infinite-scroll"

interface UseSyncInfiniteQueryPageOptions {
  page: number
  pages: readonly Pick<PaginatedData, "items" | "page">[]
  setPage: (value: number, options?: { replace?: boolean }) => void
}

/**
 * Keeps the URL/persisted page in sync with the last loaded infinite-query page
 * when that page has rows.
 */
export const useSyncInfiniteQueryPage = ({
  page,
  pages,
  setPage,
}: UseSyncInfiniteQueryPageOptions): void => {
  const lastLoadedPage = pages.at(-1)
  const currentLoadedPage = lastLoadedPage?.page
  const hasRowsInCurrentLoadedPage = (lastLoadedPage?.items.length ?? 0) > 0

  React.useEffect(() => {
    if (
      hasRowsInCurrentLoadedPage &&
      currentLoadedPage &&
      Number.isFinite(currentLoadedPage) &&
      currentLoadedPage !== page
    ) {
      setPage(currentLoadedPage, { replace: true })
    }
  }, [currentLoadedPage, hasRowsInCurrentLoadedPage, page, setPage])
}
